module.exports = __webpack_public_path__ + "img/driverCR.d328172b.png";